import React, { useState } from 'react'
import { TableSearch } from '../components'

const withSearch = Component => ({ TheadComponent, onSearch, ...rest }) => {
	const [search, setSearch] = useState('')

	const handleSearch = newSearch => {
		if(onSearch) {
			onSearch(newSearch)
		}
		setSearch(newSearch)
	}

	return(
		<Component
			{...rest}
			searchString={search}
			TheadComponent={TableSearch}
			getTheadProps={() => ({
				onSearch: handleSearch,
				isSearching: !!search,
				TheadComponent
			})}
		/>
	)
}

export default withSearch
